import React, { PureComponent } from 'react';

class Burger extends PureComponent {
    render() {
        const { toggleMenu, isMenuOpen } = this.props;
        return (
            <div 
                className={isMenuOpen ? 'burger __active' : 'burger'}
                onClick={(e) => toggleMenu()}
            />
        );
    }
}

export default Burger;



// WEBPACK FOOTER //
// ./src/components/Burger.js